module.exports = __webpack_public_path__ + "4c60f63735154bec47d2b78b1a3606b1.woff";